/**
 * Threads on AgentCore (flag `agentcoreThreads`): message list, renderer and composer bridge.
 * CanvasUI only mounts this for flagged users; everyone else keeps the existing Threads UI.
 */
export { AgentMessageList, type AgentFeedbackBridge } from './AgentMessageList';
export { AgentMarkdown } from './AgentMarkdown';
export { useAgentThread, useAgentWarmup, useThreadUrlSync, type AgentThreadController } from './useAgentThread';

/**
 * Composer bridge: which engine a submitted message goes to. External (direct-model) mode and
 * slash-command tool signals stay on the existing engine.
 */
export function routesToAgent(opts: { flagEnabled: boolean; externalMode: unknown; toolSignal: unknown }): boolean {
  return opts.flagEnabled && !opts.externalMode && !opts.toolSignal;
}
